"use strict";
/// <reference types="vite/client" />

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./App.scss";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    {/* Applico in modo dinamico lo stile del client */}
    <style>
      {`:root{--primary:var(--${import.meta.env.VITE_PRIMARY_COLOR}-hsl);--ring:var(--${import.meta.env.VITE_PRIMARY_COLOR}-hsl)}.dark{--primary:var(--${import.meta.env.VITE_PRIMARY_COLOR}-hsl);--ring:var(--${import.meta.env.VITE_PRIMARY_COLOR}-hsl)}`}
    </style>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
